import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractModel } from "../../models/ExtractModel";

export const DELETE_EXTRACT = '[Extract] Delete Extract';

export class DeleteExtractAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = DELETE_EXTRACT;

  constructor(public payload: { extractKey: string, model: ExtractModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/DeleteExtractAction.ts